import { default as CommonTools } from './utils/common'
import { formatDegree, lonLat2Mercator, loadFile, lonLatFormatFloat } from './utils/tools'
import {
  MAP_PATH,
  MODEL_PATH,
  IMAGE_PATH,
  TILE_URL
} from "./const";
import {
  OverviewMapActions,
  ChannelMapActions,
  WeatherMapActions,
  WharfMapActions,
  BoatsMapActions
} from "./index";

class MapApplication extends esmap.ESEventDispatcher {
  constructor() {
    super();

    this.map = null
    this.vue = null

    this.isMobile = null
    this.isInitComplete = false;

    this.overviewMapActions = null
    this.channelMapActions = null
    this.weatherMapActions = null
    this.wharfMapActions = null
    this.boatsMapActions = null

    // 记录是否在海底视角
    this.inSeabedShow = false

    // 存储码头vue模块对象
    this.wharfVueComponent = null
    // 存储首页vue模块对象
    this.overviewVueComponent = null
    // 存储home页vue模块对象
    this.homeVueComponent = null
    // 存储航道检测vue模块对象
    this.channelVueComponent = null

    this.floor = null;
    this.modelLayer = null;
    // this.imageLayer = null;
    this.deviceImgLayer = null;
    this.effectLayer = null;
    this.boatsMarkerList = [];

    // 记录收集点集，方便一次性打印
    this.tempCoords = [];
    this.mapStyleTools = null;

    // 数据设施 气泡
    this.dataDevicePopVueComponent = null
    this.dataDevicePopMarker = null
    // 数据设施弹窗数据集
    this.dataDevicePopData = {
      seaLevelData: {
        realSeaLevel: '',
        forcastSeaLevel: '',
        lon: '',
        lat: '',
        timeStr: ''
      },
      seaTideData: {
        flowSpeed: '',
        flowDirect: '',
        lon: '',
        lat: '',
        timeStr: ''
      },
      weatherData: {
        instantWindSD: '',
        twoMinWindSD: '',
        tenMinWindSD: '',
        averageVisibility: '',
        lon: '',
        lat: '',
        timeStr: ''
      },
    };

  }

  // 初始化地图
  initMap (pageConfig) {
    let self = this
    // 本地在线开发
    this.map = new esmap.ESWorldMap({
      container: document.getElementById('map-container'),
      // themeID: 'W2001', //主题ID
      mapDataSrc: MAP_PATH,
      cids: 'TJ00001',
      tileType: 'autonavi', // 高德瓦片地图
      token: 'escope',
      center: [13151495.769, 4750413.394],
      maximumTiles: 128,
      quality: "low",
      loadRoads: false,
      showTapTip: true,
      tileShowLevel: 6,
    })
    console.log(this.map)
    this.map.showCompass = true;
    // 开启相机广角
    this.map.mapView.camera.fov = 60;

    // 初始化场景特效
    esmap.ESEffectTool.init({
      onlineEffectThemeId: 'E2002',
      loadRoads: true, // 是否加载特效主题的路网特效
      isSetRoomEffect: true, // 是否设置瓦片建筑特效
      isShowSkybox: true, // 是否展示天空盒
      isSetModelEffect: true, // 是否设置模型特效
      isOpenScreenEffect: false, // 是否开启全屏特效
      effectQuality: this.isMobile || null,
      isShowBuildingTip: false,
      isShowWater: true,
      isTileRouteShine: true,
      isChangeTileRoute: true, // 是否允许瓦片路网样式变更
    })

    // 如果是登录触发进入，则进入地图效果不同
    if (pageConfig && pageConfig.loginSign) {
      // 初始化地图瓦片
      esmap.ESTileMap.init({
        scaleLevel: 6, // 地图默认初始化缩放等级
        // scaleLevelAnimate: false, // 地图初始化后层级变化动画, { targetLevel(目标缩放层级), duration(过渡时间) }
        tileUrl: TILE_URL, // 指定一种开源瓦片地址
        scaleLevelAnimate: { // 地图初始化后层级变化动画, 默认为false
          targetLevel: 16, // 目标缩放层级
          duration: 7.5 // 过渡时间,单位秒
        },
        isShowWater: true, // 是否应用瓦片水域特效
        tileSourceMaxLevel: 15,
        isShowTileSourceLicense: false, // 关闭瓦片源版权标识
      })
    } else {
      esmap.ESTileMap.init({
        scaleLevel: 16, // 地图默认初始化缩放等级
        tileUrl: TILE_URL, // 指定一种开源瓦片地址
        scaleLevelAnimate: false, // 地图初始化后层级变化动画, { targetLevel(目标缩放层级), duration(过渡时间) }
        isShowWater: true, // 是否应用瓦片水域特效
        tileSourceMaxLevel: 15,
        isShowTileSourceLicense: false, // 关闭瓦片源版权标识
      })
    }

    // 初始化地图交互模块实例
    this.initMapActions();

    // 当前地图加载区域的模型全部加载完成事件（仅一次）
    this.map.on('tileModelInited', function () {
      // 对外分发完成加载地图事件
      self.dispatchEvent({ type: 'mapAppInitComplete' });
      self.isInitComplete = true;
      if (self.mapContainer) self.mapContainer.clickShadeSign = false;

      // self.wharfMapActions.getBerthBoundingPoints(); // 处理地图泊位信息


      self.wharfMapActions.hiddenAreaBounding('泊位', self.wharfMapActions.berthData).then(() => {

        self.wharfMapActions.showBerthPop()//默认显示码头泊位
        mapApp.channelMapActions.showBoatRouteEffect()//显示主航道
        // self.channelVueComponent.getPopRouteBinding() //默认启动航线气泡
        // self.homeVueComponent.getPopBreakwater()//默认开启主航道入口和防波堤断口气泡监测 （气泡位置不对，暂时关闭）
      })
      self.wharfMapActions.hiddenAreaBounding('回旋水域', self.channelMapActions.convoluteData).then(() => {
        // self.channelMapActions.showConvolutePop()//默认开启回旋水域多边形
      })
      self.boatsMapActions.init(); // 船只模块交互初始化

      setTimeout(function () {
        self.initMapAnimation();
      }, 500);
      if (self.mapContainer) self.mapContainer.loadingSign = false; // 关闭三角loading动画
    })

    // 浏览器页面是否当前可见状态
    this.map.on("visibilityChanged", function (state) {
      // 当前页面不可见后，则关闭每分钟的轮询请求
      self.boatsMapActions.isLoadAisData = state != 'hidden'
    })

    // 瓦片底图等级变更
    this.map.on('tileMapLevelChange', function (level) {

      console.log(level)
      self.weatherMapActions.updateWaterWaveConfig(level);
      if (level >= 17) {
        self.overviewMapActions.closeHomePop()
      } else {
        /////摆放针对性的气泡消除函数
      }
      self.boatsMapActions.toggleBoatsImgMarker(level);

    })
    // 瓦片底图初始化完成
    this.map.on('tileMapInitComplete', function (level) {
    })
    // 地图初始化完成事件
    this.map.on('loadComplete', function () {
      let newTip = `<div class="default_box"><span id=${self.map.tapTip.spanId}></span></div>
      <div class="default_arrow"></div>`

      self.map.setTapTip(newTip);

      if (pageConfig && pageConfig.loginSign) { // 这里从登陆页进来则直接关掉loading
        document.querySelector('.loading_shade').style.display = 'none'
      }
      if (self.mapContainer) self.mapContainer.clickShadeSign = true;
      self.dispatchEvent({ type: 'mapLoadComplete' });

      console.log('地图初始化完成')

    })

    // 模型加入至场景后
    this.map.on('modelLoadComplete', function (e) {
      self.initCraneAnimation(e);
      if (e.ID && typeof e.ID == 'string' && e.ID.indexOf('boat-') > -1) {

      }
    })

    // 模型特效初始化完成事件（主要解决动态加载模型使用特效时的可用时机）
    this.map.on('modelEffectInitComplete', function (e) {
      if (e.type == 'boatFoam') {
        self.boatsMapActions.setBoatsFoamEffect(e)
      }
      if (e.type == 'uvTransform') {
        self.boatsMapActions.setBoatsCodeImg(e);
      }
    })

    // 特效包初始化完成
    this.map.on('effectsInitComplete', function (data) {
      // 获取层
      self.floor = self.map.getBuildingById(0).getFloor(1);
      self.imageLayer = self.floor.getOrCreateLayerByName('forecastLineImg', esmap.ESLayerType.IMAGE_MARKER)
      self.modelLayer = self.floor.getOrCreateLayerByName('deviceModel', esmap.ESLayerType.MODEL3D);
      self.deviceImgLayer = self.floor.getOrCreateLayerByName('deviceImg', esmap.ESLayerType.IMAGE_MARKER);
      //创建特效标注层
      self.effectLayer = new esmap.ESEffectTool.EffectLayer('initEffects', esmap.ESLayer.EFFECT_MARKER);
      esmap.ESEffectTool.addLayerToMap(self.effectLayer);

      // 交互脚本对象初始化
      self.overviewMapActions.init();
      self.channelMapActions.init();
      self.weatherMapActions.init();
      self.wharfMapActions.init();
    })

    // 地图点击事件
    this.map.on('mapClickNode', function (e) {
      console.log(e);
      let pos = { x: e.hitCoord.x, y: e.hitCoord.y, offset: 0 }
      // 记录并打印点集
      self.tempCoords.push(pos)
      // console.log(JSON.stringify(self.tempCoords));
      console.log("当前位置:",JSON.stringify(pos));

      // 获取当前相机视角
      // console.log(self.map.cameraFlyToHelper())

      if (self.inSeabedShow == false) {
        // 不在海底视角可以触发点击操作
        // 其他模块的点击事件
        self.map.options.showTapTip = true
        self.channelMapActions.managerMapClick(e);
        self.wharfMapActions.managerMapClick(e);
        self.boatsMapActions.managerMapClick(e);
        self.weatherMapActions.waterMapClick(e);
        self.managerMapClick(e);
        if (self.channelVueComponent) self.channelVueComponent.strandClick(e)
      } else {
        if (e && e.name === '海底地形') {
          self.map.selectModelNull();
          self.map.options.showTapTip = false
        }
      }

    })

  }

  // 管理地图点击
  managerMapClick (e) {
    let self = this;
    if ((e.name && e.name.indexOf('吊机') !== -1) || (e.name && e.name.indexOf('办公楼') !== -1)) {
      self.clickFacilityFocusView(e.mapCoord)
    }
    if (e.name && typeof e.name === "string" && (e.name.indexOf("潮位站") !== -1 || e.name.indexOf("气象站") !== -1 || e.name.indexOf("潮流站") !== -1)) {
      self.focusMapDataDevices(e.mapCoord);
      if (!self.dataDevicePopMarker) {
        self.createDataDevicePopMarker();
      }
      self.updateDataDevicePopMarker(e);
    }
  }

  // 初始化地图动画
  initMapAnimation () {
    this.setBuoyModels(); // 浮标
    this.setDeviceModels(); // 设备
  }

  // 初始化起重机动画
  initCraneAnimation (e) {
    // 设置忽略启用动画
    let ignoreNames = ['吊机2', '吊机9', '吊机10', '吊机11', '吊机12', '吊机13', '吊机14', '吊机15', '吊机16'];
    if ((e.model == 'diaoji.gltf' || e.model == 'diaoji2.gltf') && ignoreNames.indexOf(e.name) < 0) {
      // 港区设计是16个吊机，现场有9个(1-9),将其他的进行隐藏
      setTimeout(function () {
        e.playAnimation({
          name: 'run',   //动画名称
          time: 12,     //动画执行时间 /s
          loop: true,   //是否循环执行动画
          // loopReverse: true, // 往返循环
        });
      }, Math.random() * 10000);
    }
  }

  // 点击设备飞行聚焦
  clickFacilityFocusView (coord) {
    let self = this;
    if (self.wharfVueComponent && self.wharfVueComponent.btnActive === 3) {
      self.map.options.showTapTip = false
    }
    self.mapContainer.clickShadeSign = true
    self.map.cameraFlyTo({
      "directionAngle": 328.76, "pitchAngle": 60.79, "radius": 215,
      "x": coord.x,
      "y": coord.y,
      "z": 0,
      time: 2,
      callback: function () {
        self.map.selectModelNull();
        self.map.options.showTapTip = true
        self.mapContainer.clickShadeSign = false
      }
    })
  }

  // 聚焦地图数据生成设施位置
  focusMapDataDevices (coord) {
    this.mapContainer.clickShadeSign = true
    this.map.cameraFlyTo({
      directionAngle: 336.3,
      pitchAngle: 41.67,
      radius: 107.02,
      "x": coord.x,
      "y": coord.y,
      "z": 0,
      time: 2,
      callback: () => {
        this.map.selectModelNull();
        // this.map.options.showTapTip = true
        this.mapContainer.clickShadeSign = false
      }
    })
  }

  // 设置浮标亮点特效
  setBuoyModels () {
    loadFile("./data/boats/buoy_lights.txt").then(data => {
      let list = data.split("\n");
      let lightColors = {
        "绿光": { color: '#00ff00', coords: [], period: 1, modelPath: '/fubiao-03/fubiao-03.gltf', coordOffset: { x: -6, y: 1.5 } },
        "红光": { color: '#ff7eaa', coords: [], period: 1, modelPath: '/fubiao-01/fubiao-01.gltf', coordOffset: { x: -7, y: 1.5 } },
        "白光": { color: '#ffffff', coords: [], period: 1, modelPath: '/fubiao-02/fubiao-02.gltf' },
      }
      for (let i = 1, len = list.length; i < len; i++) {
        let str = list[i].split("|");
        let lightColorStr = str[2];
        if (str[4] && str[5] && str[3]) {
          let periodTime = str[3].substring(0, 1);
          let lon = lonLatFormatFloat(str[4]) * 1;
          let lat = lonLatFormatFloat(str[5]) * 1;
          // let gcj02 = esmap.ESMapUtil.WGS84ToGCJ02([lon, lat])
          let mc = lonLat2Mercator(lon, lat);
          // result.push({ x: mc[0], y: mc[1] });
          for (let key in lightColors) {
            if (lightColorStr.indexOf(key) > -1) {
              lightColors[key].coords.push({ x: mc[0], y: mc[1] })
              lightColors[key].period = periodTime * 1;
              break;
            }
          }
        }
      }
      let count = 0;
      for (let key in lightColors) {
        //创建特效标注层
        // let pEeffectLayer = new esmap.ESEffectTool.EffectLayer('pEffects'+key, esmap.ESLayer.EFFECT_MARKER);
        // esmap.ESEffectTool.addLayerToMap(pEeffectLayer);
        let pCoords = [];
        for (let i = 0, len = lightColors[key].coords.length; i < len; i++) {
          if (lightColors[key].coordOffset) {
            pCoords.push({
              x: lightColors[key].coords[i].x + lightColors[key].coordOffset.x,
              y: lightColors[key].coords[i].y + lightColors[key].coordOffset.y,
              height: 0.1
            })
          } else {
            pCoords.push({ x: lightColors[key].coords[i].x, y: lightColors[key].coords[i].y, height: 0.1 })
          }
        }
        let pointsMarker = CommonTools.addTwinklePointsEffect({
          height: 0.1,
          pointSize: 15,
          color: lightColors[key].color,
          animateType: 'flash', // 固定周期闪烁
          points: pCoords,
          seeThrough: true,
          showLevel: 13,
          period: lightColors[key].period
        })
        // console.log(pointsMarker)
        this.effectLayer.addMarker(pointsMarker);
        // 创建浮标模型
        for (let coord of lightColors[key].coords) {
          count++;
          let marker = CommonTools.addModelMarker({
            x: coord.x,
            y: coord.y,
            offsetHeight: -2,
            url: MODEL_PATH + lightColors[key].modelPath,
            size: 1.5,
            angle: 0,
          })
          this.modelLayer.addMarker(marker)
        }
      }
    })
  }

  // 设置地图设备模型
  setDeviceModels () {
    esmap.ESJsonFileLoader('./data/boats/devices.json').then((data) => {
      // 加载模型标注
      let modelsData = data.modelMarkers;
      for (let i = 0; i < modelsData.length; i++) {
        // let gcj02 = esmap.ESMapUtil.WGS84ToGCJ02([modelsData[i].coord[0], modelsData[i].coord[1]]);
        // let coord = lonLat2Mercator(modelsData[i].coord[0], modelsData[i].coord[1]);
        // console.log(coord);
        let marker = CommonTools.addModelMarker({
          name: modelsData[i].name,
          x: modelsData[i].mapCoord.x,
          y: modelsData[i].mapCoord.y,
          offsetHeight: modelsData[i].offsetHeight,
          url: MODEL_PATH + modelsData[i].modelPath,
          size: modelsData[i].size,
          angle: modelsData[i].angle,
        })
        // console.log(marker);
        let longAry = formatDegree(modelsData[i].coord[0])
        let latAry = formatDegree(modelsData[i].coord[1])
        modelsData[i].msgData.lon = `${longAry[0]}°${longAry[1]}'${longAry[2]}"`;
        modelsData[i].msgData.lat = `${latAry[0]}°${latAry[1]}'${latAry[2]}"`
        // console.log(modelsData[i].msgData)
        this.dataDevicePopVueComponent.setData(modelsData[i]);
        this.modelLayer.addMarker(marker)
      }
      // 加载图片标注
      let imagesData = data.imageMarkers;
      for (let i = 0; i < imagesData.length; i++) {
        let marker = CommonTools.addImageMarker({
          id: "caoliuzhan",
          name: "海上潮流站",
          x: imagesData[i].mapCoord.x,
          y: imagesData[i].mapCoord.y,
          offsetHeight: imagesData[i].offsetHeight,
          size: imagesData[i].size,
          url: IMAGE_PATH + imagesData[i].imgUrl,
          showLevel: 14,
          seeThrough: true,
        })
        this.deviceImgLayer.addMarker(marker);
      }
      this.storeDataDevicePopData();
    });
  }

  // 由于其他模块没有接口请求则存储至本地缓存（解决在其他路由页刷新的数据加载问题）
  storeDataDevicePopData () {
    localStorage.setItem("esmap_dataDevice_pop_data", JSON.stringify(this.dataDevicePopData));
  }

  // 回填数据设施弹窗数据
  backfillDataDevicePopData () {
    let dataDeviceStorage = localStorage.getItem("esmap_dataDevice_pop_data");
    if (dataDeviceStorage) {
      this.dataDevicePopData = JSON.parse(dataDeviceStorage);
    }
  }

  // 查找模型接口
  searchModels (value) {
    return new Promise((resolve, reject) => {
      esmap.ESMapUtil.search(this.map, "all", {
        types: [
          // esmap.ESLayerType.MODEL,  // (房间)
          // esmap.ESLayerType.MODEL_LABEL,  // (文字label)
          // esmap.ESLayerType.MODEL_POI, // (图片poi)
          // esmap.ESLayerType.IMAGE_MARKER, // (自定义图片标注)
          // esmap.ESLayerType.TEXT_MARKER, // (自定义文字标注)
          esmap.ESLayerType.MODEL3D, // (三维模型标注)
        ],
        keyword: value
      }, function (e) {
        resolve(e);
      })
    })
  }

  // 设置叉车
  // setChaCheMove(data) {
  //   const chacheMarker = CommonTools.addModelMarker({
  //     id: data.id,
  //     name: data.name,
  //     x: data.x,
  //     y: data.y,
  //     offsetHeight: data.offsetHeight,
  //     url: CHACHE_MODEL_PATH + data.url,
  //     size: data.size,
  //     angle: data.angle,
  //     callback: function (marker) {
  //       marker.playAnimation({ name: 'get' })
  //     },
  //   })
  //   this.modelLayer.addMarker(chacheMarker)
  // }

  /**
   * 是否显示loading
   */
  isShowLoading (isShow) {
    // document.querySelector('#loading').style.display = isShow ? 'block' : 'none'
  }
  /**
   * 初始化地图交互脚本对象
   */
  initMapActions () {
    this.boatsMapActions = new BoatsMapActions(this.map);
    this.overviewMapActions = new OverviewMapActions(this.map);
    this.wharfMapActions = new WharfMapActions(this.map);
    this.channelMapActions = new ChannelMapActions(this.map);
    this.weatherMapActions = new WeatherMapActions(this.map);
  }

  // 创建数据设施气泡弹窗
  createDataDevicePopMarker () {
    let that = this
    this.dataDevicePopMarker = CommonTools.addPopMarker({
      x: 13151625.988003284,
      y: 4750091.707444602,
      showLevel: 17
    })
    this.dataDevicePopMarker.onUpdatePosition(function (transformStyle) {
      that.dataDevicePopVueComponent.popTips.transformStyle = transformStyle
    })
  }
  // 更新数据设施气泡弹窗
  updateDataDevicePopMarker (marker) {
    if (this.dataDevicePopMarker) {
      this.dataDevicePopMarker.moveTo({ x: marker.mapCoord.x, y: marker.mapCoord.y, z: marker.mapCoord.z, time: 0 })
      this.dataDevicePopVueComponent.popTips.visible = true
      this.dataDevicePopVueComponent.dataDeviceType = marker.name;
    }
  }
  // 关闭数据设施气泡弹窗
  closeDataDevicePop () {
    if (this.dataDevicePopMarker) {
      this.dataDevicePopMarker.close()
      this.dataDevicePopMarker = null
    }
    if (this.dataDevicePopVueComponent) this.dataDevicePopVueComponent.popTips.visible = false
  }


  /**
   * 销毁地图
   */
  destroyMap () {
    this.map.dumpScene()
    // 移除地图特效配置
    esmap.ESEffectTool.clearAll()
    this.map = null
  }




}

export default new MapApplication()
